import { IconButton, InputStepper, HStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { InputMoney } from '../../../../../../../components/InputMoney';
import { RiskRating } from '../../../../../../../components/RiskRating';
import {
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { messageError } from '../../../../../../../store/batchTicket/constants';
import { treasuryMaximumQuantityItem, treasuryMaximumStepperValueItem } from '../../../../../utils';

import { AddedProductResponsiveItemDirectTreasuryProps } from '.';

export const AddedProductItemDirectTreasuryDesktop: React.FC<
  AddedProductResponsiveItemDirectTreasuryProps
> = (props) => {
  const {
    data,
    onRemoveProduct,
    inputMoneyDataProps,
    messageAdjustUnitPriceIsVisible,
    inputIsFocused,
    amountItem,
    handleChangeAmountItem,
    inputIsDisabled,
  } = props;
  return (
    <HStack
      flex={1}
      w={'full'}
      space={Spacing['inline.nano']}
      justifyContent="space-between"
      alignItems="center">
      <TableContentItemColumn flex={4} space={Spacing['inline.quarck']}>
        <TableContentItemText>{data.titleName || messageError}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <TableContentItemText>Rentabilidade</TableContentItemText>
        <TableContentItemText>{`${data.rateIncome} + ${Utils.Mask.Percentage(
          data.purchaseRate
        )}`}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <TableContentItemText>Risco</TableContentItemText>
        <RiskRating
          currentRiskRating={Number(data?.productRisk?.risk) || 0}
          tooltip={data?.productRisk?.formatRisk || messageError}
        />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <TableContentItemText>Vencimento</TableContentItemText>
        <TableContentItemText>
          {Utils.Mask.DateFormat((data.maturityDate || '') as Date, 'dd/MM/yyyy')}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <TableContentItemText>Juros</TableContentItemText>
        <TableContentItemText>{data.periodicityRate || messageError}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={1.5} space={Spacing['inline.quarck']}>
        <TableContentItemText>Quantidade</TableContentItemText>
        <InputStepper
          disabled={inputIsDisabled}
          isDisabled={inputIsDisabled}
          stepperValue={treasuryMaximumStepperValueItem}
          max={treasuryMaximumQuantityItem}
          min={data.minimumStepQuantity || 0.01}
          name="treasury-amount-order-input"
          testId="treasury-amount-order-input"
          keyboardType="numeric"
          fontSize={Typography['fontsize.md']}
          defaultValue={amountItem}
          onChange={handleChangeAmountItem}
          showErrorMessage={false}
        />
      </TableContentItemColumn>
      <TableContentItemColumn flex={1.5} space={Spacing['inline.quarck']}>
        <TableContentItemText>A partir de</TableContentItemText>
        <InputMoney {...inputMoneyDataProps} />
        {messageAdjustUnitPriceIsVisible && !inputIsFocused && (
          <TableContentItemText fontSize={Typography['fontsize.xs']} color="neutral.light">
            Ajustado por preço unitário
          </TableContentItemText>
        )}
      </TableContentItemColumn>
      <IconButton
        testId="icon-button"
        borderRadius={BoxRadius.sm}
        onPress={onRemoveProduct}
        icon="Trash"
        p={0}
        iconColor={Color['feedback.error.default']}
        iconSize="xs"
      />
    </HStack>
  );
};
